<template>
  <div class="row">
      <div class="col-md-12 col-xxl-12 col-sm-12 mb-10">
        <div class="card mb-25 border-0 rounded-0">
          <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
            <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
              <router-link to="/liste-assignation" 
              class=" btn btn-primary transition border-0 lh-1 fw-medium" >
              <i class="flaticon-left-arrow  lh-1 me-1 position-relative top-2"></i>
              <span class="position-relative"></span>Retour</router-link>
              
            </div>
            <table class="table">
              <tbody>
                <tr v-if="assignation.membre?.urlImage">
                  <td class="bl">Image:</td>
                  <td><img :src="getUrlApiForFilesMembre(assignation.membre?.urlImage)" alt="Image"  width="200" height="200" /></td>
                </tr>
                <tr v-if="assignation.mandature?.libelle">
                  <td class="bl"> Libellé Mandature</td>
                  <td>{{ assignation.mandature?.libelle}}</td>
                </tr>
                <tr v-if="assignation.poste?.nomPoste">
                  <td class="bl">Intitulé du Poste:</td>
                  <td>{{assignation.poste?.nomPoste}}</td>
                </tr>
                <tr v-if="assignation.membre?.nom && assignation.membre?.prenom">
                  <td class="bl">Nom & Prénoms du membre:</td>
                  <td>  {{ assignation.membre?.nom }} {{ assignation.membre?.prenom }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed } from "vue";
import { error, format_date,separateur,format_Date,getUrlApiForFiles,suppression, getUrlApiForFilesMembre} from "@/utils/utils";
import { useRoute } from "vue-router";
import { Article } from "@/models/Article";
import ApiService from "@/services/ApiService";

export default defineComponent({
  name: "ViewAss",
  component: {
    // YouTubeVideo,
  },
  // props: {
  //   videoUrl: {
  //     type: String,
  //     required: true,
  //   },
  // },
  setup: (props) => {
    const route = useRoute();
      const assignation = ref<any>({});
    const videoUrl = ref()
    function getAllPostMembreMandature(id: string) {
      return ApiService.get("/pmm/"+id)
        .then(({ data }) => {
            console.log("assignation reçue :", data.data);
          assignation.value = data.data;
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    } 


    onMounted(() => {
      const id = route.params.id as string;
      getAllPostMembreMandature(id);
    });

    

    return { assignation, getUrlApiForFiles,getUrlApiForFilesMembre
     };
  },
});
</script>

<style>
  .bl{
    font-weight: bold;
  }
  .badge-container {
  margin-right: 8px; 
}

.badge-outline-success {
  color: #28a745; 
  border: 1px solid currentColor; 
  padding: 5px 10px; 
  border-radius: 20px; 
  display: flex;
  align-items: center; 
  white-space: nowrap; 
}

.tag-delete-link {
  margin-left: 10px; 
  color: inherit; 
  text-decoration: none; 
}

.icon-position {
  line-height: 1;
  position: relative;
  top: 1px;
  font-size: 14px;
}

.youtube-video {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
}
.youtube-video iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>